var co = require('./internal/co');

var ob = require('./internal/ob');

module.exports = Object.assign(co, ob);